/**
 * The hero.
 *
 * The thesis in one line, the terms in the next, and the stack laid out as
 * plain mono text beside it. No image and no mockup: the studio's product is
 * software other people run, so there is nothing honest to show a picture of.
 * The stack strip is the evidence instead — a prospective client scanning for
 * "Django" or "Flutter" finds it in the first screen.
 */
import { Button } from '../components/Button';
import { useI18n } from '../i18n';
import styles from './Hero.module.css';

export function Hero() {
  const { t } = useI18n();

  return (
    <section className={styles.hero}>
      <div className="container">
        <div className={styles.inner}>
          <div className={styles.copy}>
            <p className={styles.eyebrow}>{t.hero.eyebrow}</p>
            <h1 className={styles.headline}>{t.hero.headline}</h1>
            <p className={styles.body}>{t.hero.body}</p>

            <div className={styles.ctas}>
              <Button variant="primary" size="lg" href="#proposal">
                {t.hero.ctaPrimary}
              </Button>
              <a className={styles.textLink} href="#products">
                {t.hero.ctaSecondary} <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>

          <aside className={styles.stack} aria-label={t.stack.eyebrow}>
            <ul className={styles.stackList}>
              {t.hero.stack.map((line, index) => (
                <li
                  key={line}
                  className={styles.stackItem}
                  /* Which line this is, so each types in a beat after the last. */
                  style={{ '--i': index } as React.CSSProperties}
                >
                  {line}
                </li>
              ))}
            </ul>
            <p className={styles.count}>
              <span className={styles.dot} aria-hidden="true" />
              {t.hero.productsNote}
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}
